<template>
  <div>
    <fieldset>
      <div class="row">
        <div class="col-md-7">
          <label for="address1" class="form-label">Address line 1:</label>
          <input
            class="form-control"
            type="text"
            name="address1"
            v-model="client.address1"
          />
        </div>

        <div class="col-md-7 mt-3">
          <label for="address2" class="form-label">Address line 2:</label>
          <input
            class="form-control"
            type="text"
            name="address2"
            v-model="client.address2"
          />
        </div>

        <div class="col-md-7 mt-3">
          <label for="city" class="form-label">City:</label>
          <input
            class="form-control"
            type="text"
            name="city"
            v-model="client.city"
          />
        </div>

        <div class="col-md-7 mt-3 ">
          <label for="state" class="form-label">State:</label>
          <select
            class="form-control"
            name="state"
            v-model="client.state"
            aria-label="Default select example"
          >
            <option selected>AL-Alabama</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>

        <div class="col-md-7 mt-3">
          <label for="zip" class="form-label">Zip code:</label>
          <input
            class="form-control"
            type="text"
            name="zip"
            v-model="client.zip"
          />
        </div>

        <div class="col-md-7 mt-3">
          <label for="phone" class="form-label">Phone number:</label>
          <input
            class="form-control"
            type="text"
            name="phone"
            v-model="client.phone"
          />
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "ShippingAddress",
  data() {
    return {};
  },
  computed: {
    client() {
      return this.$store.state.manageClients.client;
    },
  },
};
</script>
<style scoped>
.mb-4 {
  margin-bottom: 30px !important;
}
</style>
